/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosports4ColumnBannersData } from './hosports-4-column-banners.data';
import { IHosports4ColumnBannersProps } from './hosports-4-column-banners.props.autogenerated';

export interface IHosports4ColumnBannersViewProps extends IHosports4ColumnBannersProps<IHosports4ColumnBannersData> {

}

/**
 *
 * Hosports4ColumnBanners component
 * @extends {React.PureComponent<IHosports4ColumnBannersProps<IHosports4ColumnBannersData>>}
 */
class Hosports4ColumnBanners extends React.PureComponent<IHosports4ColumnBannersProps<IHosports4ColumnBannersData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default Hosports4ColumnBanners;
